<div class="search-input">
  <fr8bot-ui-input-field
    [(value)]="value"
    [touched]="touched()"
    [dirty]="dirty()"
    [errors]="errors()"
    [disabled]="disabled()"
    [required]="required()"
    [isErrorVisible]="isErrorVisible()"
    [label]="label()"
    [placeholder]="placeholder()"
    [size]="size()"
    (touch)="touch.emit()"
  >
    <ng-container prefix>
      <ng-content select="[search-prefix]" />
    </ng-container>
    <span class="search-input__postfix" postfix>
      @if (value()) {
        <button uiFieldAction="danger" [disabled]="disabled()" (click)="clearInput()">
          <fr8bot-ui-icon name="x" [size]="16" />
        </button>
      } @else if (!hasOuterPostfix()) {
        <!-- Open, the input is already a tab stop of its own; folded, this is the only one. -->
        <button
          uiFieldAction
          [class.search-input__toggle]="collapsed()"
          [attr.tabindex]="collapsed() ? null : -1"
          [attr.aria-label]="collapsed() ? ('common.searchField.open' | translate) : null"
          [disabled]="disabled()"
          (click)="onMagnifierClick()"
        >
          <fr8bot-ui-icon name="search-16" [size]="16" />
        </button>
      }
      <span class="search-input__outer-postfix empty-hidden">
        <ng-content select="[search-postfix]" />
      </span>
    </span>
  </fr8bot-ui-input-field>
</div>
